import { GoToCheckoutButton } from '#components/molecules/Cart/buttons/GoToCheckoutButton/GoToCheckoutButton.js';
import { useShopProvider } from '#provider/useShopProvider.js';
import { LoadingOverlay } from 'ui';

import { useUserShopCarts } from '../../../cart/useUserShopCarts';
import { useShopStorage } from '../../../hooks/useShopStorage';
import { CartContainer } from './CartContainer';

type CartsProps = {
  onClickCheckout?: () => void;
};

/**
 * Renders a list of carts with their details and Cart Subtotal for all carts
 * Will render an an individual checkout button for each cart that will navigate to the checkout page for that cart when consolidated checkout is not enabled.
 */
const Carts = ({ onClickCheckout }: CartsProps) => {
  const { getCartByCartId } = useShopStorage();
  const { carts, isLoading } = useUserShopCarts();
  const { isNPOStore } = useShopProvider();
  const { isConsolidatedCheckoutEnabled: isEnabled } = useShopProvider();

  return (
    <>
      {carts?.map((cart) => {
        if (!cart) return null;
        const storeId = getCartByCartId(cart.uuid);
        if (!storeId) return null;
        return (
          <CartContainer
            key={cart.uuid}
            id={cart.uuid}
            storeId={storeId.storeId}
            showGivingaDisclaimer={cart.processed_via === 'givinga'}
            disableCartItemNameClick={isNPOStore}
            checkOutButton={
              isEnabled ? null : (
                <GoToCheckoutButton onCheckoutClick={onClickCheckout} cartId={cart.uuid} />
              )
            }
          />
        );
      })}

      <LoadingOverlay visible={isLoading} />
    </>
  );
};

export { Carts };
